export const ApiEndPoint = "https://vkadmin-api.coolkaru.com/";
export const NoData = "No Data";
export const GSTAPI = "https://appyflow.in/api/verifyGST";
export const GSTApiSecretKey = "Jzip0DNzGqUKEaB7rLTKbgxRGU32";
export const logo = "VK";
